import { AwardEmbeds, getAward } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

export const SINGLE_AWARD_QK = 'SINGLE_AWARD'

const awardEmbeds: AwardEmbeds[] = [
  'recipientCount',
  'badgeUrls',
  'sendToAndSender',
  'comments',
  'reactionCounts',
  'endorsementStats',
  'translations',
  'qualities',
]

const useAwardData = (awardId?: string, enabled: boolean = true) => {
  const {
    data: awardData,
    isLoading,
    refetch,
    isFetched,
  } = useQuery({
    queryKey: [SINGLE_AWARD_QK, awardId],
    queryFn: () => getAward(awardId ?? '', { embeds: awardEmbeds }),
    enabled: !!awardId && enabled,
  })

  return { awardData, isLoading, refetch, isFetched }
}

export default useAwardData
